import { render, staticRenderFns } from "./BottomSection.vue?vue&type=template&id=2b56276c&scoped=true"
import script from "./BottomSection.vue?vue&type=script&lang=js"
export * from "./BottomSection.vue?vue&type=script&lang=js"
import style0 from "./BottomSection.vue?vue&type=style&index=0&id=2b56276c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b56276c",
  null
  
)

export default component.exports